/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './WithUserPermissions.scss';

import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isSalesforceRepEnabled } from 'state/view/ViewSelectors';

const WithUserPermissions = (WrappedComponent) => {
  class PermissionsCheck extends Component {
    constructor(props) {
      super(props);
      this.killClick = this.killClick.bind(this);
    }

    killClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    render() {
      // We do not want to pass dispatch as props to the wrapped component
      const {
        isSalesforceRepEnabled,
        dispatch, // eslint-disable-line no-unused-vars
        webViewEnabled,
        shouldDisable = false,
        shouldMask = false,
        styleOverride = {},
        ...passThroughProps
      } = this.props;

      const disclaimer = "You don't have permission to access";

      const classes = classNames({
        modified: true,
        blocked_data: shouldMask
      });

      /**
       * DEVELOPER WARNING - Test the children that are wrapped by this component it was meant to
       * be unobtrusive to layout, but because a container element was needed to wrap the
       * the child component there might be display consequences depending the on the underlying child styles
       * later on this can be check against user entitlements but for now this only concerned with CWV
       */
      return webViewEnabled && shouldDisable && !isSalesforceRepEnabled ? (
        <div onClickCapture={this.killClick} className="cwv-disable-wrapper">
          <div
            title={disclaimer}
            aria-label={disclaimer}
            className="cwv-disable"
            data-testid="cwv-disabled"
          />
          <div className={classes} style={styleOverride}>
            <WrappedComponent {...passThroughProps} />
          </div>
        </div>
      ) : (
        <div className={classes} style={styleOverride}>
          <WrappedComponent {...passThroughProps} />
        </div>
      );
    }
  }

  const mapStateToProps = (state) => ({
    isSalesforceRepEnabled: isSalesforceRepEnabled(state),
    webViewEnabled: state.customer.webViewEnabled
  });

  return connect(mapStateToProps)(PermissionsCheck);
};

export default WithUserPermissions;
